import { reportUnhandledError as reportErrorInternal } from "../instrumentations/errors/unhandled-error";
export function reportError(error, opts) {
    reportErrorInternal(error, opts);
}
